import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Dropdown } from "@/react/components/shared/uikit/Dropdown";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useCommunitySettingShow } from "@/react/hooks/UseCommunitySetting";
import { useControlsDropdownContext } from "./context";

const i18nBase = "members_directory.controls_dropdown.root_selector";

export const RootSelector = () => {
  const { setCurrentComponent } = useControlsDropdownContext();
  const { data, isLoading } = useCommunitySettingShow();

  const communitySetting = data?.community_settings;

  const isPublicMemberDirectory = Boolean(
    communitySetting?.public_member_directory,
  );

  const defaultView = communitySetting?.member_directory_settings?.view;
  const defaultSort = communitySetting?.member_directory_settings?.sort;

  return (
    <>
      <Dropdown.ItemGroup>
        <Dropdown.ItemWithLink
          onClick={e => {
            e.preventDefault();
            setCurrentComponent("visibility");
          }}
        >
          <Dropdown.IconContainer>
            <Icon type="20-lock" size={20} />
            <Typography.LabelSm weight="medium" color="text-darkest">
              {t(`${i18nBase}.visibility`)}
            </Typography.LabelSm>
            <span className="ml-auto">
              {isLoading ? (
                <Loader className="size-5 !p-0" />
              ) : (
                <Typography.LabelSm color="text-default">
                  {t(
                    `members_directory.controls_dropdown.visibility_selector.${isPublicMemberDirectory ? "public" : "private"}`,
                  )}
                </Typography.LabelSm>
              )}
            </span>
          </Dropdown.IconContainer>
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={e => {
            e.preventDefault();
            setCurrentComponent("sort");
          }}
        >
          <Dropdown.IconContainer>
            <Icon type="20-arrow-up-down" size={20} />
            <Typography.LabelSm weight="medium" color="text-darkest">
              {t(`${i18nBase}.sort`)}
            </Typography.LabelSm>
            <span className="ml-auto">
              {isLoading ? (
                <Loader className="size-5 !p-0" />
              ) : (
                <Typography.LabelSm color="text-default">
                  {t(
                    `members_directory.controls_dropdown.sort_selector.${defaultSort}`,
                  )}
                </Typography.LabelSm>
              )}
            </span>
          </Dropdown.IconContainer>
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={e => {
            e.preventDefault();
            setCurrentComponent("view");
          }}
        >
          <Dropdown.IconContainer>
            <Icon type="20-layout" size={20} />
            <Typography.LabelSm weight="medium" color="text-darkest">
              {t(`${i18nBase}.view`)}
            </Typography.LabelSm>
            <span className="ml-auto">
              {isLoading ? (
                <Loader className="size-5 !p-0" />
              ) : (
                <Typography.LabelSm color="text-default">
                  {t(
                    `members_directory.controls_dropdown.view_selector.${defaultView}`,
                  )}
                </Typography.LabelSm>
              )}
            </span>
          </Dropdown.IconContainer>
        </Dropdown.ItemWithLink>
      </Dropdown.ItemGroup>
      <Dropdown.ItemGroup>
        <Dropdown.ItemWithLink>
          <Link
            className="text-darkest hover:text-darkest flex items-center gap-2 no-underline"
            to="/audience/manage"
          >
            <Icon type="20-group" size={20} />
            <Typography.LabelSm weight="medium" color="text-darkest">
              {t(`${i18nBase}.manage`)}
            </Typography.LabelSm>
            <span className="ml-auto">
              <Icon type="16-arrow-top-right" size={16} />
            </span>
          </Link>
        </Dropdown.ItemWithLink>
      </Dropdown.ItemGroup>
    </>
  );
};
